function makeInterceptorContext() {
  const interceptors = /* @__PURE__ */ new Set();
  return {
    addInterceptor(interceptorName, interceptor) {
      const context = [interceptorName, interceptor];
      interceptors.add(context);
      return () => {
        interceptors.delete(context);
      };
    },
    async runInterceptors(nextPath) {
      const cancelRef = {
        current: false
      };
      const cancelToken = {
        isCancelled: () => cancelRef.current,
        cancel: () => {
          cancelRef.current = true;
        }
      };
      for (const [interceptorName, interceptor] of interceptors) {
        await interceptor(cancelToken, nextPath);
        if (cancelToken.isCancelled()) {
          console.info(`interceptors.${interceptorName}: Navigation prevented`);
          break;
        }
      }
      return cancelToken;
    }
  };
}

export { makeInterceptorContext };
//# sourceMappingURL=util.interceptors.js.map
